<template>
	<div id='inqui-editar'>
		<h2>EDITAR INQUILINO</h2>
		<form v-on:submit.prevent= 'guardarInquilino'>
		<table align="center">
			<tr>
				<td>nombreCompleto</td>
				<td><input type="text" name="nombreCompleto" v-model="inquilinos.nombreCompleto"></td>
			</tr>
			<tr>
				<td>email</td>
				<td><input type="text" name="email" v-model="inquilinos.email"></td>
			</tr>
			<tr>
				<td>celular</td>
				<td><input type="text" name="celular" v-model="inquilinos.celular"></td>
			</tr>
			<tr>
				<td>telefonoFijo</td>
				<td><input type="text" name="telefonoFijo" v-model="inquilinos.telefonoFijo"></td>
			</tr>
			<tr>
				<td>whatsapp</td>
				<td><input type="text" name="whatsapp" v-model="inquilinos.whatsapp"></td>
			</tr>
			<tr>
				<td>facebook</td>
				<td><input type="text" name="facebook" v-model="inquilinos.facebook"></td>
			</tr>
			<tr>
				<td>dirCalle</td>
				<td><input type="text" name="dirCalle" v-model="inquilinos.dirCalle"></td>
			</tr>
			<tr>
				<td>dirNumero</td>
				<td><input type="text" name="dirNumero" v-model="inquilinos.dirNumero"></td>
			</tr>
			<tr>
				<td>dirInterior</td>
				<td><input type="text" name="dirInterior" v-model="inquilinos.dirInterior"></td>
			</tr>
			<tr>
				<td>dirColonia</td>
				<td><input type="text" name="dirColonia" v-model="inquilinos.dirColonia"></td>
			</tr>
			<tr>
				<td>dirCodigo</td>
				<td><input type="text" name="dirCodigo" v-model="inquilinos.dirCodigo"></td>
			</tr>
			<tr>
				<td>dirCiudad</td>
				<td><input type="text" name="dirCiudad" v-model="inquilinos.dirCiudad"></td>
			</tr>
			<tr>
				<td>dirEstado</td>
				<td><input type="text" name="dirEstado" v-model="inquilinos.dirEstado"></td>
			</tr>
			
		</table>
		<br>
		<input type="submit" name="agregandoInquilino">
		</form>
	</div>
</template>

<script>
	import axios from 'axios';
	export default{
			name:'editar-inquilino',
			mounted(){
				var inq= ''; 
				var inquilinos2= '';

				this.id=this.$route.params.id;
				axios.get('https://www.directodo.com/Rentus/accesosdb/leeUnInquilino.php?id='+this.id)
  		             .then((respue) => {
  		     			inq=respue.data;
  		     			
  		     			var x;
  		     			for (x in inq) {
    						inquilinos2 = inq[x];
						}

						this.inquilinos.id = inquilinos2.id;
						this.inquilinos.nombreCompleto = inquilinos2.nombreCompleto;
						this.inquilinos.email = inquilinos2.email;
						this.inquilinos.celular = inquilinos2.celular;
						this.inquilinos.telefonoFijo = inquilinos2.telefonoFijo;
						this.inquilinos.whatsapp = inquilinos2.whatsapp;
						this.inquilinos.facebook = inquilinos2.facebook;
						this.inquilinos.dirCalle = inquilinos2.dirCalle;
						this.inquilinos.dirNumero = inquilinos2.dirNumero;
						this.inquilinos.dirInterior = inquilinos2.dirInterior;
						this.inquilinos.dirColonia = inquilinos2.dirColonia;
						this.inquilinos.dirCodigo = inquilinos2.dirCodigo;
						this.inquilinos.dirCiudad = inquilinos2.dirCiudad;
						this.inquilinos.dirEstado = inquilinos2.dirEstado;

  			 		 });
			},
			data(){
				return {
					id: null,
					inquilinos:{
						id:'',
						nombreCompleto:'',
						email:'',
						celular:'',
						telefonoFijo:'',
						whatsapp:'',
						facebook:'',
						dirCalle:'',
						dirNumero:'',
						dirInterior:'',
						dirColonia:'',
						dirCodigo:'',
						dirCiudad:'',
						dirEstado:'',
						status:'',
						fechaModifica:'',
						quienModifico:''					
					}
				};
			},
			methods:{
				guardarInquilino(){
					var inquilinos3= this.inquilinos;
					var router= this.$router;

					axios.post('https://www.directodo.com/Rentus/accesosdb/modificaInquilino.php?id='+inquilinos3.id+'&nombreCompleto='+inquilinos3.nombreCompleto+'&email='+inquilinos3.email+'&celular='+inquilinos3.celular+'&telefonoFijo='+inquilinos3.telefonoFijo+'&whatsapp='+inquilinos3.whatsapp+'&facebook='+inquilinos3.facebook+'&dirCalle='+inquilinos3.dirCalle+'&dirNumero='+inquilinos3.dirNumero+'&dirInterior='+inquilinos3.dirInterior+'&dirColonia='+inquilinos3.dirColonia+'&dirCodigo='+inquilinos3.dirCodigo+'&dirCiudad='+inquilinos3.dirCiudad+'&dirEstado='+inquilinos3.dirEstado+'&fechaModifica='+'01-01-18'+'&quienModifico=GGUV')
		  		          .then((respue) => {
		  		          		if (respue.statusText == 'OK'){
		  		          			router.push('/inq')
		  		          		}
		  			 	  })
		  		          .catch((error) =>{
		  		          		console.log(error);
		  		          });
				}
			}
	}
</script>


// WEBPACK FOOTER //
// src/Inquilino-editar.vue